(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ochre-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ochre-footer-links')) {
    customElements.define('ochre-footer-links', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(min-width: 750px)');
        this.syncMenus = () => this.querySelectorAll('details').forEach(menu => { menu.open = this.media.matches; });
        this.syncMenus();
        this.media.addEventListener('change', this.syncMenus);
      }
      disconnectedCallback() {
        this.media?.removeEventListener('change', this.syncMenus);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ochre-size-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ochre-size-finder')) {
    customElements.define('ochre-size-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.choices = [...this.querySelectorAll('button[data-size]')];
        this.results = this.querySelector('.ochre-sizes__results');
        this.grid = this.querySelector('.ochre-sizes__grid');
        this.status = this.querySelector('.ochre-sizes__status');
        this.more = this.querySelector('.ochre-sizes__more');
        this.choices.forEach(button => button.addEventListener('click', () => this.selectSize(button)));
        this.more.addEventListener('click', () => this.appendProducts());
        this.querySelector('.ochre-sizes__reset').addEventListener('click', () => {
          this.results.hidden = true;
          this.grid.replaceChildren();
          this.choices.forEach(button => button.setAttribute('aria-pressed', 'false'));
          this.choices[0]?.focus();
        });
      }
      selectSize(button) {
        this.chosenSize = button.dataset.size;
        this.matchingProducts = [...this.querySelectorAll('template[data-sizes]')].filter(template =>
          template.dataset.audience === button.dataset.audience && template.dataset.sizes.includes(`|${button.dataset.size}|`)
        );
        this.choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
        this.cursor = 0;
        this.grid.replaceChildren();
        this.status.textContent = this.dataset.resultLabel.replace('%size%', button.dataset.size).replace('%audience%', button.dataset.label);
        this.results.hidden = false;
        this.appendProducts();
      }
      appendProducts() {
        const batch = this.matchingProducts.slice(this.cursor, this.cursor + 4);
        batch.forEach(template => {
          const fragment = template.content.cloneNode(true);
          const variant = template.dataset.variants.split('|').find(value => value.startsWith(`${this.chosenSize}:`));
          if (variant) {
            const link = fragment.querySelector('a');
            const url = new URL(link.getAttribute('href'), window.location.origin);
            url.searchParams.set('variant', variant.split(':')[1]);
            link.href = `${url.pathname}${url.search}`;
          }
          this.grid.append(fragment);
        });
        this.cursor += batch.length;
        this.more.hidden = this.cursor >= this.matchingProducts.length;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
